module.exports = __webpack_public_path__ + "img/shopping.eb993ccc.png";